// extracted by mini-css-extract-plugin
module.exports = {"shopItemTitle":"shop-item-module--shopItemTitle--3OWLE","shopItemPrice":"shop-item-module--shopItemPrice--3Wwfb","previewImage":"shop-item-module--previewImage--37onK"};